module.exports = __webpack_public_path__ + "media/images/favicon-907f29efd9280e83f66f0e75ba174bbb.ico";